var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 161,
    viewBox: "0 0 162 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 80.5,
    r: 79,
    stroke: "#62D0DF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 69.7666L82.6603 90.3891L120.579 69.7666L86.512 36.8542C83.4303 33.877 78.5501 33.8565 75.4435 36.8077L40.75 69.7666Z",
    fill: "#F8F7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0125 90.5624L40.75 69.7666L75.4435 36.8077C78.5501 33.8565 83.4303 33.877 86.512 36.8542L120.579 69.7666L82.3417 90.5624",
    stroke: "#23356F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.6426,
    y: 48.4583,
    width: 58.7167,
    height: 46.6417,
    fill: "white",
    stroke: "#62D0DF",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 58,
    width: 35,
    height: 3,
    rx: 1.5,
    fill: "#62D0DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 66,
    width: 41,
    height: 3,
    rx: 1.5,
    fill: "#62D0DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 74,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#62D0DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 69.7666C67.0467 69.7666 105.374 101.967 121.25 118.067H40.75V69.7666Z",
    fill: "#F8F7F6",
    stroke: "#23356F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.25 69.7666C94.9533 69.7666 56.6264 101.967 40.75 118.067H121.25V69.7666Z",
    fill: "#F8F7F6",
    stroke: "#23356F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0a6ebd61d34920abc6b40a3dbe55e109.svg";
export { ForwardRef as ReactComponent };